import { NewSearchPageMVP } from "./NewSearchPageMVP.component";
import { searchFooterCss } from "./NewSearchPageMVP.styles";

export { NewSearchPageMVP, searchFooterCss };
